<template>
  <v-form lazy-validation @submit.prevent="onSubmit" ref="form">
    <v-card-text>
      <div class="text-center mb-4">
        <h3 :style="{ color: corTexto }" class="recover-title">
          Redefinir Senha
        </h3>
        <p :style="{ color: corTexto }" class="recover-subtitle">
          Digite o código enviado para seu email e sua nova senha
        </p>
      </div>

      <v-text-field
        v-model="payload.codigoRecuperacao"
        label="Código de Verificação"
        :rules="codigoRules"
        required
        solo
        background-color="white"
        class="mb-3 codigo-field"
        placeholder="000000"
        style="color: #000 !important"
        hide-details="auto"
      ></v-text-field>

      <div class="text-center mb-3">
        <v-btn
          text
          :disabled="reenviarDisabled"
          @click="reenviarCodigo"
          class="resend-btn"
          :style="{ color: corTexto }"
        >
          {{ reenviarTexto }}
        </v-btn>
      </div>

      <v-text-field
        v-if="!showNewPassword"
        id="password"
        label="Nova Senha"
        name="password"
        type="password"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        solo
        background-color="white"
        class="mb-2"
        append-icon="mdi-eye-off"
        @click:append="showNewPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showNewPassword"
        id="password"
        label="Nova Senha"
        name="password"
        type="text"
        v-model="payload.senha"
        :rules="passwordRules"
        required
        solo
        background-color="white"
        class="mb-2"
        append-icon="mdi-eye"
        @click:append="showNewPassword = false"
      ></v-text-field>

      <v-text-field
        v-if="!showConfirmPassword"
        id="confirm-password"
        label="Confirme a senha"
        name="confirm-password"
        type="password"
        v-model="payload.confirmacaoSenha"
        :rules="confirmPasswordRules"
        required
        solo
        background-color="white"
        class="mb-3"
        append-icon="mdi-eye-off"
        @click:append="showConfirmPassword = true"
      ></v-text-field>
      <v-text-field
        v-if="showConfirmPassword"
        id="confirm-password"
        label="Confirme a senha"
        name="confirm-password"
        type="text"
        v-model="payload.confirmacaoSenha"
        :rules="confirmPasswordRules"
        required
        solo
        background-color="white"
        class="mb-3"
        append-icon="mdi-eye"
        @click:append="showConfirmPassword = false"
      ></v-text-field>

      <div class="mt-5" :style="{ color: corTexto }">
        <div
          v-for="(especificacao, index) in especificacaoSenha"
          :key="index"
          :class="errosSenha.includes(especificacao.name) ? 'falta' : ''"
        >
          - {{ especificacao.title }}
        </div>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col>
          <div class="text-center">
            <v-btn type="submit" class="trocar-senha-btn" large>
              Trocar Senha
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { userAPI } from "@/modules/user";
import {
  regexSenhaQuebrado,
  especificacaoLabels,
} from "@/helpers/senhaEspecificacao";
import Swal from "sweetalert2";
import verificarTonalidadeCor from "@/helpers/verificarTonalidadeCor";
import { atualUfDefinition } from "@/helpers/utils";

export default {
  props: {
    email: {
      type: String,
      required: true,
    },
  },

  mounted() {
    // this.verificarToken();
    this.iniciarCountdown();
  },
  computed: {
    ...mapGetters(["isSala", "logos"]),
    corTexto() {
      if (verificarTonalidadeCor(atualUfDefinition.corPrimaria))
        return "rgba(0, 0, 0, 0.6)";

      return "#fff";
    },

    corPrimaria() {
      return atualUfDefinition.corPrimaria || "#1976d2";
    },

    reenviarTexto() {
      if (this.reenviarDisabled) {
        return `Reenviar código (${this.countdown}s)`;
      }
      return "Reenviar código";
    },
  },
  data() {
    return {
      payload: {
        tokenRecuperacao: this.$route.params.token,
        codigo: "",
      },
      especificacaoSenha: especificacaoLabels,
      errosSenha: [],
      showNewPassword: false,
      showConfirmPassword: false,
      regexSenhaQuebrado: regexSenhaQuebrado,
      reenviarDisabled: false,
      countdown: 30,
      countdownInterval: null,

      codigoRules: [(v) => !!v || "Código é obrigatório"],
      confirmPasswordRules: [
        (v) => !!v || "O campo confirmação de senha é obrigatório",
        (v) => {
          if (v !== this.payload.senha) {
            return "As senhas devem ser iguais";
          }
          return true;
        },
      ],
      passwordRules: [
        (v) => !!v || "O campo nova senha é obrigatório",
        (v) => {
          if (v && !this.regexSenhaQuebrado.totalRegex.test(v)) {
            this.errosSenha = [];
            !this.regexSenhaQuebrado.letraMinuscula.test(v) &&
              this.errosSenha.push("minuscula");
            !this.regexSenhaQuebrado.letraMaiuscula.test(v) &&
              this.errosSenha.push("maiuscula");
            !this.regexSenhaQuebrado.numero.test(v) &&
              this.errosSenha.push("numero");
            !this.regexSenhaQuebrado.especial.test(v) &&
              this.errosSenha.push("especial");
            v.length < 8 && this.errosSenha.push("caracteres");

            return "Senha fraca";
          }
          this.errosSenha = [];
          return true;
        },
      ],
      userRules: [(v) => !!v || "O campo usuário é obrigatório"],
      logo: this.$store.state.logo,
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    verificarToken() {
      userAPI
        .verificarToken(this.$route.params.token)
        .then((_) => {})
        .catch((err) => {
          Swal.fire({
            title: "Atenção!",
            text: err.response.data,
            confirmButtonText: "Entendi",
          }).then((result) => {
            this.$router.push("/auth/login");
          });
        });
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async onSubmit() {
      var isValid = await this.check();
      if (!isValid) return;
      this.setLoading(true);
      this.payload.email = this.email;

      // Inclui validação do código junto com troca de senha
      userAPI
        .trocarSenha(this.payload)
        .then((resp) => {
          if (!resp.data) {
            this.setLoading(false);
            this.$notification.error("Código inválido.", { timer: 10 });
          } else {
            this.setLoading(false);
            this.$router.push("/auth/login");
          }
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao recuperar senha!", { timer: 10 });
        });
    },

    async reenviarCodigo() {
      if (this.reenviarDisabled) return;

      this.setLoading(true);

      try {
        // Chama a mesma rota de recuperar senha
        await userAPI.recuperarSenha({ email: this.email });

        this.$notification.success("Código reenviado com sucesso!");
        this.iniciarCountdown();
      } catch (error) {
        console.error("Erro ao reenviar código:", error);
        this.$notification.error("Erro ao reenviar código. Tente novamente.");
      } finally {
        this.setLoading(false);
      }
    },

    iniciarCountdown() {
      this.reenviarDisabled = true;
      this.countdown = 30;

      this.countdownInterval = setInterval(() => {
        this.countdown--;

        if (this.countdown <= 0) {
          this.reenviarDisabled = false;
          clearInterval(this.countdownInterval);
          this.countdownInterval = null;
        }
      }, 1000);
    },
  },

  beforeDestroy() {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  },
};
</script>
<style lang="scss" scoped>
.falta {
  color: red;
  font-weight: 500;
}

.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.logoImg {
  width: 250px;
  max-width: 100%;
  height: auto;
}

.recover-title {
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 8px;
}

.recover-subtitle {
  font-size: 16px;
  opacity: 0.8;
  line-height: 1.4;
  margin-bottom: 16px;
}

.resend-btn {
  font-size: 14px;
  text-transform: none;
  margin-bottom: 16px;

  &:disabled {
    opacity: 0.6;
    color: #fff !important;
  }
}

.trocar-senha-btn {
  margin-top: 16px;
  padding: 12px 32px;
  font-weight: 600;
}

// Garantir que todos os inputs tenham texto escuro
::v-deep .v-input input {
  color: #000000 !important;
}

::v-deep .v-input .v-label {
  color: #666666 !important;
}

::v-deep .v-input .v-input__slot {
  background-color: white !important;
}

::v-deep .v-text-field.v-text-field--solo .v-input__control .v-input__slot {
  background-color: white !important;
  color: #000000 !important;
}

::v-deep .v-text-field input {
  color: #000000 !important;
}

// Responsividade para telas menores
@media screen and (max-width: 770px) {
  .logoImg {
    width: 200px;
  }

  .recover-title {
    font-size: 20px;
  }

  .recover-subtitle {
    font-size: 14px;
  }

  .trocar-senha-btn {
    padding: 10px 24px;
  }
}
</style>

<style lang="scss">
@import "../style.scss";
</style>
